import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import {Field, formValueSelector} from 'redux-form';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {DateField} from 'components/Fields';

import {validDate} from 'utils/validators';
import {DATE_FORMAT, DATE_FORMAT_API} from 'utils/datetime';
import ErrorBlock from 'components/ErrorBlock';

const formSelector = formValueSelector('createBookingExtension');

export const initialValues = state => {
  const selectedBookingValue = formSelector(state, 'booking');
  const selectedBookingEndDate = _.get(
    selectedBookingValue,
    'object.period.endDate'
  );

  if (selectedBookingEndDate) {
    /*
      Extension booking's startDate default
      should be the day after the selected booking's endDate
    */
    return {
      startDate: moment(selectedBookingEndDate, DATE_FORMAT_API)
        .add(1, 'days')
        .format(DATE_FORMAT)
    };
  }

  return {startDate: null};
};

const BookingPeriodSection = ({onEndChange, startDateGreaterThаnEndDate}) => (
  <div>
    <FormField>
      <Label>Booking start</Label>
      <Field
        name="startDate"
        component={DateField}
        validate={[validDate]}
        disabled={true}
      />
    </FormField>
    <FormField>
      <Label>Booking end</Label>
      <Field
        name="endDate"
        component={DateField}
        validate={[validDate]}
        onDateChange={onEndChange}
      />
    </FormField>
    {startDateGreaterThаnEndDate && (
      <ErrorBlock>
        {'End date should be greater than or equal to start date'}
      </ErrorBlock>
    )}
  </div>
);

export default BookingPeriodSection;
